import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { CurrentUserService } from './current-user.service';
import { NavigationService } from 'app/modules/global/services/navigation.service';
import { AuthenticationService } from './authentication.service';

export const AuthGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const router = inject(Router);
  const currentUserService = inject(CurrentUserService);
  const navigationService = inject(NavigationService);
  const authenticationService = inject(AuthenticationService);

  const isValidUser = currentUserService.isValidUser$();
  // console.log('AuthGuard: isValidUser', isValidUser, route, segments, router);

  const redirectUrl = router.currentNavigation()?.extractedUrl?.queryParams?.['returnUrl'];
  // console.log('AuthGuard: redirectUrl', redirectUrl);
  if (route.path === 'auth') {
    if (isValidUser) {
      if (redirectUrl) {
        try {
          router
            .navigateByUrl(redirectUrl)
            .then((navigated) => {
              if (!navigated) {
                router.navigate(['/dashboard']);
              }
            })
            .catch(() => router.navigate(['/dashboard']));
        } catch {
          router.navigate(['/dashboard']);
        }
        return false;
      }
      return router.createUrlTree(['/dashboard']);
    }
    return true;
  } else {
    if (isValidUser) {
      return true;
    }
    authenticationService.logout();
    const returnUrl = navigationService.buildUrlFromSegments(segments);
    return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl } });
  }
};
